import { cssGenerator } from '@yola/ws-sdk';

const { MARGIN_TOP, MARGIN_BOTTOM, LINE_HEIGHT } = cssGenerator.constants.attributes;

const removeLineAndParagraphSpacingFromNode = (node) => {
  node.removeAttribute(MARGIN_TOP);
  node.removeAttribute(MARGIN_BOTTOM);
  node.removeAttribute(LINE_HEIGHT);
};

export default removeLineAndParagraphSpacingFromNode;
